import { ApplicationRef, ComponentRef, EnvironmentInjector, inject, Injectable, createComponent } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ChatContainerComponent } from '../components/chat-container/chat-container.component';

@Injectable({ providedIn: 'root' })
export class ChatHostService {
  private componentRef?: ComponentRef<ChatContainerComponent>;
  private readonly document = inject(DOCUMENT);

  constructor(
    private readonly appRef: ApplicationRef,
    private readonly environmentInjector: EnvironmentInjector,
  ) {}

  public open(): void {
    this.ensureComponent();
  }

  public close(): void {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = undefined;
    }

    const hostElement = this.document.querySelector('.sc-chat-host');
    if (hostElement) {
      hostElement.remove();
    }
  }

  private ensureComponent(): ChatContainerComponent {
    if (this.componentRef) {
      return this.componentRef.instance;
    }

    const hostElement = this.document.createElement('div');
    hostElement.classList.add('sc-chat-host');

    this.componentRef = createComponent(ChatContainerComponent, {
      environmentInjector: this.environmentInjector,
      hostElement,
    });

    this.componentRef.instance.closeChat.subscribe(() => this.close());

    this.appRef.attachView(this.componentRef.hostView);
    this.document.body.appendChild(hostElement);

    this.detectChanges();
    return this.componentRef.instance;
  }

  private detectChanges(): void {
    this.componentRef?.changeDetectorRef.detectChanges();
  }
}
